module.exports = __webpack_public_path__ + "assets/img/cdinet.5dcc4e60.png";